module.exports = __webpack_public_path__ + "static/img/Geos-2022-Noiralih.b37eb24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Noiralih.png
// module id = ykot
// module chunks = 0